const Whatsapp = () => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.796875"
                width="25.6"
                height="25.6"
                rx="4.8"
                fill="#D6F4E6"
            />
            <path
                d="M6.90039 19.9953L7.80012 16.7084C7.24492 15.7462 6.95319 14.6556 6.95372 13.5372C6.95532 10.0406 9.80065 7.19531 13.2966 7.19531C14.9932 7.19585 16.5857 7.85664 17.7836 9.05557C18.9809 10.2545 19.6401 11.8481 19.6396 13.543C19.638 17.0401 16.7926 19.8854 13.2966 19.8854C12.2353 19.8849 11.1894 19.6188 10.263 19.1132L6.90039 19.9953ZM10.4188 17.9649C11.3126 18.4956 12.166 18.8134 13.2945 18.814C16.2001 18.814 18.567 16.4492 18.5686 13.542C18.5697 10.6289 16.214 8.26731 13.2988 8.26624C10.391 8.26624 8.02572 10.631 8.02465 13.5377C8.02412 14.7244 8.37185 15.6129 8.95585 16.5425L8.42305 18.4881L10.4188 17.9649ZM16.4918 15.0508C16.4524 14.9846 16.3468 14.9452 16.1878 14.8657C16.0294 14.7862 15.2502 14.4028 15.1046 14.35C14.9596 14.2972 14.854 14.2705 14.7478 14.4294C14.6422 14.5878 14.3382 14.9452 14.246 15.0508C14.1537 15.1564 14.0609 15.1697 13.9025 15.0902C13.7441 15.0108 13.2332 14.8438 12.6278 14.3036C12.1569 13.8833 11.8385 13.3644 11.7462 13.2054C11.654 13.047 11.7366 12.9612 11.8156 12.8822C11.887 12.8113 11.974 12.6972 12.0534 12.6044C12.134 12.5126 12.1601 12.4465 12.2134 12.3404C12.2662 12.2348 12.2401 12.142 12.2001 12.0625C12.1601 11.9836 11.8433 11.2033 11.7116 10.886C11.5825 10.5772 11.4518 10.6188 11.3548 10.614L11.0508 10.6086C10.9452 10.6086 10.7734 10.6481 10.6284 10.807C10.4833 10.966 10.0737 11.3489 10.0737 12.1292C10.0737 12.9094 10.6417 13.663 10.7206 13.7686C10.8001 13.8742 11.838 15.4753 13.4278 16.1617C13.806 16.3249 14.1014 16.4225 14.3313 16.4956C14.711 16.6161 15.0566 16.599 15.3297 16.5585C15.6342 16.5132 16.2673 16.175 16.3996 15.8049C16.5318 15.4342 16.5318 15.1169 16.4918 15.0508Z"
                fill="#068048"
            />
        </svg>
    )
}

export default Whatsapp
